
export default {
    mounted () {
        const { path } = this.$route;

        const payload = {
            WebComponent: path
        };

        // Log event so we can compare the number of serverside requests vs successful mounts
        this.$log.info(`Client availability log for ${path}`, '', payload);
    }
};
